import type { ComponentType } from 'react';
import {
  IconBug,
  IconBulb,
  IconAlertTriangle,
  IconStar,
  IconMessageQuestion,
  IconDots,
} from '@tabler/icons-react';
import { FeedbackType, FeedbackStatus, FeedbackPriority } from '../../api/model';

export type IconComponent = ComponentType<{ size?: number | string; stroke?: number; className?: string }>;

// Icon per feedback type
export const TYPE_ICON: Record<FeedbackType, IconComponent> = {
  [FeedbackType.BUG]: IconBug,
  [FeedbackType.IMPROVEMENT]: IconBulb,
  [FeedbackType.ERROR]: IconAlertTriangle,
  [FeedbackType.FEATURE_REQUEST]: IconStar,
  [FeedbackType.QUESTION]: IconMessageQuestion,
  [FeedbackType.OTHER]: IconDots,
};

// Status color declarations
export const STATUS_COLOR: Record<FeedbackStatus, string> = {
  [FeedbackStatus.OPEN]: '#2f6fd0',
  [FeedbackStatus.IN_PROGRESS]: '#b7791f',
  [FeedbackStatus.NEEDS_INFO]: '#7c5cc4',
  [FeedbackStatus.RESOLVED]: '#1f9d57',
  [FeedbackStatus.REOPENED]: '#0e8a8a',
  [FeedbackStatus.REJECTED]: '#b4443a',
  [FeedbackStatus.CLOSED]: '#6b7280',
};

export const PRIORITY_COLOR: Record<FeedbackPriority, string> = {
  [FeedbackPriority.URGENT]: '#c0392b',
  [FeedbackPriority.HIGH]: '#c2790f',
  [FeedbackPriority.MEDIUM]: '#8a7320',
  [FeedbackPriority.LOW]: '#5f7488',
};

// Sort weights
export const PRIORITY_WEIGHT: Record<FeedbackPriority, number> = {
  [FeedbackPriority.URGENT]: 4,
  [FeedbackPriority.HIGH]: 3,
  [FeedbackPriority.MEDIUM]: 2,
  [FeedbackPriority.LOW]: 1,
};

export const TYPE_VALUES = Object.values(FeedbackType) as FeedbackType[];
export const STATUS_VALUES = Object.values(FeedbackStatus) as FeedbackStatus[];
export const PRIORITY_VALUES = Object.values(FeedbackPriority) as FeedbackPriority[];

export const canClose = (status?: FeedbackStatus): boolean =>
  status !== undefined && status !== FeedbackStatus.CLOSED;

export const canReopen = (status?: FeedbackStatus): boolean =>
  status === FeedbackStatus.RESOLVED ||
  status === FeedbackStatus.CLOSED ||
  status === FeedbackStatus.REJECTED;
